import React from 'react';
import { useNavigate } from 'react-router';

import { BackButton, NOTIFICATION_TYPE, Notification } from 'components';
import { CarrierForm } from 'features/carriers/components/form/CarrierForm';

export default function AddCarrier() {
  const navigate = useNavigate();

  const onSuccess = () => {
    Notification(NOTIFICATION_TYPE.SUCCESS, 'Carrier was created successfully');
    navigate(-1);
  };

  const onError = (error) => {
    Notification(NOTIFICATION_TYPE.DANGER, error.message);
  };

  return (
    <div>
      <div className="mb-4">
        <BackButton />
      </div>

      <div className="row mb-4">
        <h1>Add Carrier</h1>
      </div>

      <CarrierForm action="create" onSuccess={onSuccess} onError={onError} />
    </div>
  );
}
